import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { isAdminNotConsultant } from "@/js/http/auth.js";
import { listWineTypes } from "@/js/lists.ts";
import WineNaming from "@/components/products/WineNaming.vue";
export default {
  name: "WineDuplicateListDialog",
  components: {
    WineNaming: WineNaming
  },
  props: {
    loggedUserData: Object,
    wines: Array
  },
  data: function data() {
    return {
      shown: false,
      options: {
        color: "primary",
        zIndex: 2000
      }
    };
  },
  created: function created() {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    productDetails: function productDetails(wine) {
      var detailsRoute = isAdminNotConsultant(this.loggedUserData) ? wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails" : wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "userSpiritsDetails" : "userWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine
        }
      };
    }
  }
};